import React from "react";
import SoftwareFeaturesData from "../Data/SoftwareFeaturesData.json";

const SoftwareFeatures = () => {
  return (
    <>
      <section id="software-feature" className="software-feature-area">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 col-md-6 col-12 wow fadeInLeft"
              data-wow-delay="1s"
            >
              <div className="software-feature-title">
                <h3>Choose the right package for you.</h3>
                <p>Enjoy all the features and install more Add-ons.</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 wow fadeInUp" data-wow-delay="1.5s">
              <div className="software-package">
                <div className="table100">
                  <table>
                    <thead>
                      <tr className="table100-head">
                        <th className="column1">
                          <div className="head-title">Software Features</div>
                        </th>
                        <th className="column2">
                          <div className="head-title">Basic Plan</div>
                        </th>
                        <th className="column3">
                          <div className="head-title">Standard Plan</div>
                        </th>
                        <th className="column4">
                          <div className="head-title">Premium Plan</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {SoftwareFeaturesData.map((SingleFeatures) => (
                        <tr key={SingleFeatures.id}>
                          <td className="column1">
                            <div className="b-title">
                              {SingleFeatures.features[0].title}
                            </div>
                          </td>
                          <td className="column2">
                            <i className={SingleFeatures.features[0].basic}></i>
                          </td>
                          <td className="column2">
                            <i
                              className={SingleFeatures.features[0].standard}
                            ></i>
                          </td>
                          <td className="column4">
                            <i
                              className={SingleFeatures.features[0].premium}
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SoftwareFeatures;
